"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropdownOptionFragment = void 0;
exports.dropdownOptionFragment = `
  fragment dropdown on DropdownOption {
    isSelected
    label
    value
  }
`;
//# sourceMappingURL=dropdown-option.js.map